export const formField = `
    .form-field {
        align-items: center;
        display: grid;
        row-gap: 1rem;
    }
`